import { FC } from 'react';
import { ReactComponent as EmptyActives } from '../../../../../assets/img/errors/EmptyState_NoConnections.svg';

interface ThereIsNotActivesProps {
    title: string;
    subtitle: string;
}

const ThereIsNotActives: FC<ThereIsNotActivesProps> = ({ title, subtitle }) => {
    return (
        <div className="flex justify-center item-center w-full h-[53px]">
            <EmptyActives className="h-[53px] w-[85px]" />
            <div className="flex flex-col justify-center ml-4">
                <h1 className="font-poppins font-semibold text-[12px] leading-3 text-[#B0BEC5]">{title}</h1>
                <h2 className="font-roboto font-normal text-[12px] leading-5 text-[#78909C]">{subtitle}</h2>
            </div>
        </div>
    );
};

export default ThereIsNotActives;
